import Nav from "./../Page/Share/Nav/Nav";
const Post25 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            Brand Moodboard
          </h2>
          {/* items?.Description */}
          <p>

          </p>
          {/* img section */}
          <img src="https://i.ibb.co/NWcRWZ3/1.png" alt="" />
          <img src="https://i.ibb.co/dptxgpf/2.png" alt="" />
          <img src="https://i.ibb.co/7NyBJhf/3.png" alt="" />
          <img src="https://i.ibb.co/PxTT4q9/4.png" alt="" />
          <img src="https://i.ibb.co/2FT9pJp/5.png" alt="" />
          <img src="https://i.ibb.co/4RBsQc3/6.png" alt="" />
          <img src="https://i.ibb.co/XYhs6jB/7.png" alt="" />
          <img src="https://i.ibb.co/42kbGLF/8.png" alt="" />
          <img src="https://i.ibb.co/Q9sK0y8/9.png" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post25;
